<template>
  <ListSkeleton
    v-if="!isFamilyRequestDone"
    data-qa="appointment_patient_list_skeleton"
    :class="isMobile ? 'px-2' : 'px-6'"
  />
  <v-list
    v-else
    data-qa="appointment_family_profiles"
  >
    <v-list-item
      v-for="({ patient, errorDescription, patientItemData }, index) in patientListData"
      :key="`item-${index}`"
      data-qa="appointment_family_profiles_patient"
      :class="{ 'px-6': !isMobile }"
      :disabled="!!errorDescription"
      @click="handleClickPatient(patient)"
    >
      <v-list-item-content>
        <v-list-item-title class="d-flex align-end">
          <div
            data-qa="appointment_family_profiles_patient_fio"
            class="text-body-1"
            :class="errorDescription ? 'icon-secondary--text' : 'text--text'"
          >
            {{ patientItemData.fio }}
          </div>
          <div
            v-if="patientItemData.isEmptyMain"
            class="text-body-2 text-secondary--text ml-2"
          >
            {{ $i18next.t('Основной профиль', options) }}
          </div>
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="patientItemData.age || errorDescription"
          class="text-body-2 mt-1"
        >
          <div
            v-if="patientItemData.age"
            data-qa="appointment_family_profiles_patient_age"
            :class="errorDescription ? 'icon-secondary--text' : 'text-secondary--text'"
          >
            {{ patientItemData.age }}
          </div>
          <div
            v-if="errorDescription"
            data-qa="appointment_family_profiles_patient_error_description"
            class="text-error--text"
          >
            {{ $i18next.t(errorDescription, options) }}
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-icon class="align-self-center my-auto">
        <v-icon
          :class="errorDescription ? 'disabled--text' : 'text-secondary--text'"
        >
          ui-icon-arrow-right
        </v-icon>
      </v-list-item-icon>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState } from 'pinia'
import ListSkeleton from 'www/vue_components/common/ListSkeleton/ListSkeleton.vue'
import { DEFAULT_PATIENTS_DATA } from 'www/vue_components/common/AppointmentPage/constants'
import useFamilyProfilesStore from 'www/vue_components/common/FamilyProfiles/stores/useFamilyProfilesStore'

export default {
  name: 'AppointmentPatientList',
  components: {
    ListSkeleton,
  },
  data: vm => ({
    isVisibleDialog: false,
    isMobile: window.MOBILE_VERSION,
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    ...mapState(useFamilyProfilesStore, [
      'patientList',
      'isFamilyRequestDone',
    ]),
    ...mapState(useFamilyProfilesStore, [
      'fioValidationRules',
      'birthDayValidationRules',
      'genderValidationRules',
    ]),
    patientListData() {
      return this.patientList.map(patient => {
        const failedBirthDayValidationRule = patient.birthDay
          ? this.birthDayValidationRules.find(rule => rule(patient.birthDay) !== true)
          : ''
        const errorDescription = failedBirthDayValidationRule
          ? failedBirthDayValidationRule(patient.birthDay)
          : ''

        const patientItemData = {
          fio: patient.fio,
          age: patient.isOther ? '' : patient.age,
        }

        if (patient.isMain) {
          if (!this.isPatientValid(patient)) {
            patientItemData.isEmptyMain = true
            patientItemData.fio = this.$t(DEFAULT_PATIENTS_DATA.main.fio, this.options)
          }
        } else if (patient.isOther) {
          patientItemData.fio = this.$t(DEFAULT_PATIENTS_DATA.other.fio, this.options)
        }

        return {
          patientItemData,
          patient,
          errorDescription,
        }
      })
    },
  },
  methods: {
    getValidationResults(patient) {
      return {
        surname: this.fioValidationRules.surname.every(rule => rule(patient.surname) === true),
        name: this.fioValidationRules.name.every(rule => rule(patient.name) === true),
        patronymic: patient.hasPatronymic
          ? this.fioValidationRules.patronymic.every(rule => rule(patient.patronymic) === true)
          : true,
        birthDay: this.birthDayValidationRules.every(rule => rule(patient.birthDay) === true),
        gender: this.genderValidationRules.every(rule => rule(patient.gender) === true),
      }
    },
    isPatientValid(patient, validationResults = undefined) {
      return Object.values(validationResults || this.getValidationResults(patient)).every(result => result)
    },
    handleClickPatient(patient) {
      if (patient.isOther) {
        this.$emit('appointment-patient-list:click-invalid', {
          patient,
          validationResults: {
            surname: false,
            name: false,
            patronymic: false,
            birthDay: false,
            gender: false,
          },
        })

        return
      }

      const validationResults = this.getValidationResults(patient)
      const isValidPatient = this.isPatientValid(patient, validationResults)

      if (!isValidPatient) {
        this.$emit('appointment-patient-list:click-invalid', {
          patient,
          validationResults,
        })

        return
      }

      this.$emit('appointment-patient-list:click-valid', patient)
    },
  },
}
</script>
